<template>
  <div>
    <v-btn
      v-if="allowChange"
      :disabled="loading"
      fab
      small
      title="تغییر وضعیت"
      @click="dialog = true"
    >
      <v-icon>mdi-swap-horizontal</v-icon>
    </v-btn>

    <custom-popup
      v-model="dialog"
      :cons="{ title: 'تغییر وضعیت' }"
      hide-confirm
      max-width="400"
    >
      <v-card-text>
        <v-radio-group v-model="status" dense hide-details row>
          <v-radio label="موفق" value="success" />
          <v-radio label="ناموفق مطلق" value="stall" />
        </v-radio-group>
      </v-card-text>

      <v-card-actions>
        <v-btn
          :disabled="!status"
          block
          class="ma-0 btn-accept"
          @click="changeStatus"
          :loading="loading"
        >
          ثبت وضعیت
        </v-btn>
      </v-card-actions>
    </custom-popup>
  </div>
</template>

<script>
export default {
  name: "paymentChangeStatus",

  props: {
    data: Object,
  },

  data: () => ({
    loading: false,
    dialog: false,
    status: "",
  }),

  computed: {
    allowChange() {
      const moment = require("moment");

      return (
        !["success", "stall"].includes(this.data.status) &&
        !moment().diff(this.data.created_at.split(" ")[0], "days")
      );
    },
  },

  methods: {
    changeStatus() {
      if (!this.allowChange) return;

      this.loading = true;

      axios
        .post(`${this.$robotApi}/admin/bazaar/manual/verify/${this.data.id}`, {
          status: this.status,
        })
        .then(({ data }) => {
          this.$toast.success(data?.message || "وضعیت با موفقیت تغییر یافت.");
          this.$root.$emit("changeStatus");
        })
        .catch(({ response }) => {
          console.log("failed to change status: ", response);
          this.$toast.error(response?.data?.message || "خطا در تغییر وضعیت!");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
